<template>
  <div>
    <h4>Anciennes parties</h4>
    <div class="container-fluid">
      <table class="table table-stripped table-sm">
        <thead>
          <tr>
            <th>Date</th>
            <th>Score</th>
            <th>Top</th>
            <th>% du Top</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="game in orderedGames" v-bind:key="game.id">
            <td>
              <router-link v-bind:to="`/ended-games/${game.gameId}`">{{convertDate(game.createdAt)}}
              </router-link>
            </td>
            <td>{{game.score}}</td>
            <td>{{game.totalTop}}</td>
            <td>{{ ((game.score / game.totalTop) * 100).toFixed(2)}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>

export default {
  name: 'UserGameList',
  props: {
    games: {
      type: Array,
      required: true,
    },
  },
  computed: {
    orderedGames() {
      return this.games.slice(0).sort((a, b) => b.createdAt - a.createdAt);
    },
  },
  methods: {
    convertDate(timestamp) {
      const d = new Date(timestamp);
      return `${d.toLocaleDateString()} ${d.toLocaleTimeString()}`;
    },
  },
};
</script>

<style scoped>
h1{
  text-align: center;
}
</style>
